import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";

import styles from './FiltersModalForCleaners.module.scss';
import close from "../../constants/images/close.svg";
import {servicePackagesActions} from "../../store/slices/servicePackagesSlice";
import MainButtonTransparentBackground from "../UI/MainButtonTransparentBackground/MainButtonTransparentBackground";
import MainButtonWithBackground from "../UI/MainButtonWithBackground/MainButtonWithBackground";
import {filtersForCleanerActions} from "../../store/slices/filtersForCleanerSlice";

const FiltersModalForCleaners = ({handleClose, page, setPage}) => {
    const dispatch = useDispatch();
    const {servicePackages} = useSelector(state => state.servicePackages);
    const {min_price, max_price, package_names} = useSelector(state => state.filtersForCleaner);

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    useEffect(() => {
        const getServicePackages = async () => {
            await dispatch(servicePackagesActions.getAll());
        }

        getServicePackages();
    }, [])

    const handleChangeMinPrice = (event) => {
        const minPrice = event.target.value;

        dispatch(filtersForCleanerActions.setMinPrice(minPrice));
    }

    const handleChangeMaxPrice = (event) => {
        const maxPrice = event.target.value;

        dispatch(filtersForCleanerActions.setMaxPrice(maxPrice));
    }

    const handleApplyFilters = () => {
        dispatch(filtersForCleanerActions.setTrigger());
        handleClose(); // close modal
    }

    const handleChangePackageNames = (event) => {
        if (event.target.value === package_names) {
            dispatch(filtersForCleanerActions.setPackageNames(''));
        } else {
            dispatch(filtersForCleanerActions.setPackageNames(event.target.value));
        }
    };

    return (
        <div className={styles.filtersModalForCleaners}>
            <div className={styles.filtersModalForCleaners_content}>
                <div className={styles.filtersModalForCleaners_content_title}>
                    <h2>Фільтри</h2>
                    <img
                        onClick={handleClose}
                        style={{cursor: "pointer"}}
                        src={close}
                        alt="close icon"
                    />
                </div>

                <div className={styles.filtersModalForCleaners_content_diviver}></div>
                <div className={styles.filtersModalForCleaners_content_price}>
                    <p className={styles.subtitle}>Вартість клінінгу</p>
                    <div className={styles.filtersModalForCleaners_content_price_container}>
                        <label className={styles.label}>
                            Від
                            <input
                                name={'min_price'}
                                onChange={handleChangeMinPrice}
                                className={styles.input}
                                type="number"
                                defaultValue={min_price}
                            />
                        </label>
                        <div className={styles.minus}></div>
                        <label className={styles.label}>
                            До
                            <input
                                name={'max_price'}
                                onChange={handleChangeMaxPrice}
                                className={styles.input}
                                type="number"
                                defaultValue={max_price}
                            />
                        </label>
                    </div>
                </div>
                <div className={styles.filtersModalForCleaners_content_diviver}></div>
                <div className={styles.filtersModalForCleaners_content_servicePackage}>
                    <p className={styles.subtitle}>Тип прибирання</p>
                    {/*{servicePackages.map((item, index) => (*/}
                    {/*    <FormControlLabel*/}
                    {/*        key={index}*/}
                    {/*        control={<Checkbox style={{ color: '#F97B22' }} />}*/}
                    {/*        label={item.name}*/}
                    {/*    />*/}
                    {/*))}*/}
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={package_names}
                        // onChange={handleChangePackageNames}
                        onClick={handleChangePackageNames}
                        name="radio-buttons-group"
                        className={styles.radioGroup}
                    >
                        {servicePackages.map((item, index) =>
                            <FormControlLabel
                                key={index}
                                value={item.name}
                                control={<Radio style={{color: '#405BD8'}}/>}
                                label={item.name}
                                style={{cursor: 'auto'}}
                                // onClick={handleChangePackageNames}
                            />)}
                    </RadioGroup>
                </div>

                <div className={styles.filtersModalForCleaners_content_buttons}>
                    <MainButtonTransparentBackground
                        onClick={handleClose}
                        text={'Скасувати'}
                        type={'button'} // button, submit, reset
                        width={windowWidth > 768 ? 'auto' : '100%'}
                        condition={false} // is button disabled
                    />

                    <MainButtonWithBackground
                        onClick={handleApplyFilters}
                        text={windowWidth > 768 ? 'Застосувати Фільтри' : 'Застосувати'}
                        type={'button'} // button, submit, reset
                        width={windowWidth > 768 ? 'auto' : '100%'}
                        condition={false} // is button disabled
                    />
                </div>
            </div>
        </div>
    );
};

export default FiltersModalForCleaners;
